export default __webpack_public_path__ + "static/media/applyLeaveWhite.8104aa8e.svg";